<template>
  <v-dialog v-if="dialog" v-model="dialog" scrollable persistent max-width="75%">
    <v-card class="primary--text">
      <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
        {{ $t('dialog_titulo') | capitalize }}
        <v-spacer></v-spacer>
        <v-btn icon right @click="cerrar" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <visualizar-material-personalizado :material="material"/>
            </v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col class="primary--text font-weight-bold px-0 pt-6" offset="3">{{ $t("titulo_evaluacion") }}</v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col class="pa-0" offset="3">{{ $t("descrip_evaluacion") }}</v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0 pt-2" offset="3">
              <v-select v-model="usoEvaluar" :items="usos" item-text="nombre" return-object :label="$t('usos')"
                        clearable hide-details/>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0 pt-6 offset-3">
              <p>* {{$t('infoMaterial')}}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" text @click="cerrar()">
          {{ $t('cerrar') | capitalize }}
        </v-btn>
        <v-btn color="primary" depressed :disabled="!usoEvaluar" @click="evaluar(material)">
          {{ $t('btn_evaluar') | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import VisualizarMaterialPersonalizado from "@/components/VisualizarMaterialPersonalizado";

export default {
  name: "BtnAddMaterialPers",
  props: {
    mostrar: {type: Boolean, required: true},
    disabled: {type: Boolean, default: false},
    material: {type: Object, required: true},

  },
  model: {
    prop: 'mostrar',
    event: 'change'
  },
  components: {
    VisualizarMaterialPersonalizado
  },
  data: () => ({
    dialog: false,
    usoEvaluar: null,
    usos: [],
    absorcionAgua: [],
  }),
  watch: {
    dialog: function (val) {
      if (val) this.init();
    },
    mostrar(val) {
      this.dialog = val;
    }
  },
  methods: {
    init() {
      this.usos = this.material.usos
      this.cargarAbsorcionAgua();
    },
    cargarAbsorcionAgua() {
      HttpHelper.get("material-personalizado/absorcion-agua")
          .then((resp) => {
            this.absorcionAgua = resp;
          });
    },
    cerrar() {
      this.dialog = false;
      this.$emit("cerrado");
    },
    evaluar(material) {
      let params = {uso: this.usoEvaluar};
      if (material.ceramicos.length > 0) params.ceramicoPers = material;
      else {
        params.noCeramicoPers = material;
      }

      this.$router.push({name: 'proyecto-nuevo', params: params})
    },
    valido() {
      if (this.material.noCeramicos.length === 0) return this.usoEvaluar;

      return this.usoEvaluar;
    }
  }
}
</script>

<style lang="scss">
.v-card {
  border-color: #40108e !important;
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "descrip_empresa": "Información de la empresa",
    "descrip_producto": "Descripción del producto",
    "label_marca": "Marca:",
    "label_colec": "Colección - Pieza:",
    "label_enlace": "Enlace web:",
    "label_formato": "Formato (cm):",
    "label_espesor": "Espesor (mm):",
    "dialog_titulo": "Información del material",
    "absorcion_agua": "Absorción de agua",
    "titulo_evaluacion": "Evaluación del material",
    "descrip_evaluacion": "En caso de querer proceder a la evaluación del material, seleccione el tipo uso de destino:",
    "btn_evaluar": "Evaluar",
    "usos": "Tipo de uso / Solucion constructiva",
    "tipo_material": "Tipo de material",
    "infoMaterial" : "Los datos de este producto que se utilizarán para su evaluación han sido introducidos por cada una de las empresas y su contenido es responsabilidad de las mismas."
  }
}
</i18n>
<!--@formatter:on-->